import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const alertDialogFn = /* @__PURE__ */ createRecipe('AlertDialog', {
  "palette": "neutral"
}, [])

const alertDialogVariantMap = {
  "palette": [
    "neutral",
    "primary",
    "warning",
    "danger"
  ]
}

const alertDialogVariantKeys = Object.keys(alertDialogVariantMap)

export const alertDialog = /* @__PURE__ */ Object.assign(memo(alertDialogFn.recipeFn), {
  __recipe__: true,
  __name__: 'alertDialog',
  __getCompoundVariantCss__: alertDialogFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: alertDialogVariantKeys,
  variantMap: alertDialogVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, alertDialogVariantKeys)
  },
  getVariantProps: alertDialogFn.getVariantProps,
})